import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./TableHeader.module.css";
import { IoChevronDown } from "react-icons/io5";
import FilterModal from "../Modals/FilterModal/FilterModal";
import { HeaderGroup } from "react-table";
import classNames from "classnames";
import { useSelector,connect } from "react-redux";
import ApiFilterModal from "../Modals/FilterModal/ApiFilterModal";
import { FaDotCircle } from "react-icons/fa";
import {themeColors} from "../../Components/theme";

type props = {
  headerGroups: HeaderGroup<any>[];
  selectAll?: (check: boolean) => void;
  allCheck?: boolean;
  setAllCheck?: (value: boolean) => void;
  panel:
  | "Organization"
  | "Super admin"
  | "User"
  | "Project"
  | "Task"
  | "CallLogs"
  | "LeadDistributor"
  | "API" 
  | "API Leads"
  | "NEWS"
  | "DrillDown"
  | "Custom Button"
  | 'Reenquired'
  | "projects"
  |'DeletedLogs'
  ;
  theme:any;
  // themeColors:any;
  DrillDownpanel?:any;
  organizationData?: any;
  callRecordingModule?: any;
};

type prop = {
  item: any;
  index: number;
  column: any;
  filterOpenIndex: number;
  setShowFiter: (index: number) => void;
  panel:
  | "Organization"
  | "Super admin"
  | "User"
  | "Project"
  | "Task"
  | "CallLogs"
  | "LeadDistributor"
  | "API"
  | "API Leads"
  | "NEWS"
  | "DrillDown"
  | "Custom Button"
  | 'Reenquired'
  | "projects"
  |'DeletedLogs'
  ;
  filter: any;
  theme:any;
  DrillDownpanel?:any;
};

const Header: FunctionComponent<prop> = ({
  item,
  index,
  column,
  filterOpenIndex,
  setShowFiter,
  panel,
  filter,
  theme,
  DrillDownpanel
}) => {
  const role = useSelector((state: any) => state.user.role);
  const [hideAnim, setHideAnim] = useState(false);
  const [showNameTooltip, setShowNameTooltip] = useState(false);
  const iconClass = classNames(
    styles.icon,
    { [styles.iconOpen]: index === filterOpenIndex },
    { [styles.iconClose]: hideAnim === true }
  );
  const [open, setOpen] = useState(false);

  const handleMouseEnter = () => {
    setShowNameTooltip(true);
  };

  const handleMouseLeave = () => {
    if (!open) {
      setShowNameTooltip(false);
    }
  };
  const handleTooltipClick = () => {
    setShowNameTooltip(true);
    setOpen(true);
  };

  const handleCloseTooltip = () => {
    setShowNameTooltip(false);
    setOpen(false);
  };

  return (
    <div key={index} 
    onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    // onMouseEnter={() => {
    //   setShowNameTooltip(true)
    // }} 
    // onClick={()=>{setShowNameTooltip(true)}}
    // onMouseLeave={()=>{
    //   setShowNameTooltip(false)
    // }}
    >
      <div className={styles.th} 
      // style={{maxWidth:panel==="LeadDistributor"?showNameTooltip ? "none": '210px' :showNameTooltip ? "none":"",minWidth:panel==="LeadDistributor"?'210px':''}}
      style={{maxWidth: showNameTooltip ? "none":""}}
      >
      <div className={styles.tHeadContainer}>
        {/* <p style={{marginTop:"12px"}}>{item.slice(0,8)}</p> */}
        <th style={{marginTop:"8px",marginBottom:"8px",color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}}>{(showNameTooltip || item === "Buyer Intent") ? item : item.slice(0,8)}</th>
        <IoChevronDown
          size={18}
          style={{padding:"none"}}
          color={theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
          className={iconClass}
          onClick={(e) => {
            if (item !== "Buyer Intent") {
              if (index === filterOpenIndex) {
                setHideAnim(true);
                setShowFiter(-1);
                handleCloseTooltip()
              } else {
                setHideAnim(false);
                setTimeout(() => {
                  handleTooltipClick()
                  setShowFiter(index)
                }, 100)
                // setTimeout(() => setShowFiter(index), 100);
              }
            }
          }}
        /> 
        {localStorage[`${panel + role + index}`] !== "[]" &&
          localStorage[`${panel + role + index}`] && (
            <div className={styles.tooltip}>
              <FaDotCircle
                size={8}
                color={"yellow"}
                style={{ marginBottom: "16px" }}
              />
              <span className={styles.tooltiptext}>
                Filter
              </span>
            </div>
          )}
      </div>
      </div>
      <div
        style={
          index === filterOpenIndex
            ? { display: "flex" }
            : { display: "none" }
        }
        className={styles.expandFilter}
      >
        {panel === "User" ||
          panel === "Project" ||
          panel === "Task" ||
          panel === "CallLogs" ||
          panel === "Reenquired" ||
          panel==="LeadDistributor" ||
          panel==="API" ||
          panel==="API Leads" ||
          panel==="projects" ||
          panel==="DeletedLogs"
          ? (
          <ApiFilterModal
            filterId={panel + role + index}
            column={column}
            expand={index === filterOpenIndex}
            hide={() => {
              setShowFiter(-1);
              handleCloseTooltip()
            }}
            filter={filter.props.column.id}
            panel={panel}
            DrillDownpanel = {DrillDownpanel}
          />
        ) : (
          <FilterModal
            filterId={panel + role + index}
            column={column}
            expand={index === filterOpenIndex}
            hide={() => {
              setShowFiter(-1);
              handleCloseTooltip()
            }}
            filter={filter.props.column.id}
            // panel={panel}
            // DrillDownpanel = {DrillDownpanel}
          />
        )}
      </div>
    </div>
  );
};

const TableHeader: FunctionComponent<props> = ({
  headerGroups,
  selectAll,
  setAllCheck,
  allCheck,
  panel,
  // themeColors,
  theme,
  DrillDownpanel,
  organizationData,
  callRecordingModule
}) => {
  const [filterOpenIndex, setFilterOpenIndex] =
    useState(-1);

  const showFiter = (index: number) => {
    setFilterOpenIndex(index);
  };

  const thStyles = {
    backgroundColor:theme ? themeColors.thBackgroundColor:themeColors.thBackgroundColorDark,
  }
  const thTextStyles = {
    color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark
  }
  return (
    <div 
    style={{
    ...thStyles,
    position: "sticky",
    minWidth:"175vw",
    top: 0,
    zIndex: 2,
  }}
    // className="card p-1 shadow rounded align-middle  bg-light sticky-top"
    >
      {headerGroups.map((headerGroup) => (
        <div
          {...headerGroup.getHeaderGroupProps()}
          style={{
            display: "flex",
            flexDirection: "row",
            position: "sticky",
            top: 0,
            zIndex: 2,
            // height:"30px"
          }}
        >
          <div className={styles.sticky} style={{...thStyles,...thTextStyles}}>
            <div className={styles.snoDiv}>
              <input
              style={{marginLeft:"16px",marginTop:"10px",marginBottom:"10px"
              // ,accentColor:"#808080"
            }}
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    setAllCheck && setAllCheck(true);
                    selectAll && selectAll(true);
                  } else {
                    setAllCheck && setAllCheck(false);
                    selectAll && selectAll(false);
                  }
                }}
                checked={allCheck}
                disabled={panel==="LeadDistributor" || panel==="API"}
              />
              {/* <p style={{marginTop:"14px"}}>Sr. No.</p> */}
              <th style={{marginTop:"8px",marginBottom:"8px",...thTextStyles}}>S.No</th>
            </div>
          </div>
          {headerGroup.headers.map((column, index) => (
            <div
              // className={styles.th}
              {...column.getHeaderProps()}
              // style={{maxWidth:panel==="LeadDistributor"?'210px':'',minWidth:panel==="LeadDistributor"?'210px':''}}
            >     
              <Header
                item={column.render("Header")}
                index={index}
                column={column}
                setShowFiter={showFiter}
                filterOpenIndex={filterOpenIndex}
                panel={panel}
                filter={column.render("accessor")}
                theme={theme}
                DrillDownpanel={DrillDownpanel}
              />
            </div>
          ))}
          <div style={{ display: "flex", flexDirection: "row", marginTop: "8px", marginBottom: '-8px' }}>
            {(callRecordingModule.is_call_recording_subscribed && callRecordingModule.is_call_recording_enabled && panel === 'CallLogs')  && (
              <div className={styles.thSmall}>
                <p>Call Recording</p>
              </div>
            )}
          </div>
          <div style={{display:"flex",flexDirection:"row",marginTop:"8px",marginBottom:'-8px'}}>
          {panel === "Organization" && (
            <div className={styles.thSmall}>
              <p>Active/Inactive</p>
            </div>
          )}
          {/* {panel === "Organization" && (
            <div className={styles.thSmall}>
              <p>Migrate Permissions</p>
            </div>
          )} */}
          {panel === "Organization" && (
            <div className={styles.thSmall}>
              <p>Assigned Branches</p>
            </div>
          )}
          {/* {panel === "Organization" && (
            <div className={styles.thSmall}>
              <p>Primary Lead Manager</p>
            </div>
          )} */}
          </div>
          {
            panel === "Super admin" && (
              <div className={styles.tHeadContainer}>
                {/* <p style={{marginTop:"12px"}}>{item.slice(0,8)}</p> */}
                <th style={{  fontSize: "14px",padding:"0 50px",marginTop:"8px",marginBottom:"8px",color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}}>Live Tracking Permission</th>
              </div>
            )
          }
          {panel === "Project" && (
            <div className={styles.th}>
              <p></p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme:state.theme.isLightMode,
    organizationData: state.organization.organizationData,
    callRecordingModule: state.callRecordingModule
  };
};

export default connect(mapStateToProps)(TableHeader);
